import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm, change} from 'redux-form';

import {required} from 'utils/validators';

import FormField from 'components/FormField';
import Label from 'components/Label';
import {TextField, CheckBoxField, DropzoneField} from 'components/Fields';
import Dropzone from 'components/Dropzone';

import {fetchLocations, selectLocations} from 'ducks/locations';
import {uploadFile, ACCEPTED_IMAGE_FILE_TYPES} from 'ducks/files';
import {storeDataInModal, selectModal} from 'ducks/modals';
import {MODALS} from 'ducks/teams';

import {teamAvatarSignOnCreate} from 'sdk/teams';

import {Section} from './components';
import './styles.css';

class AddTeamDetailsForm extends React.Component<any> {
  state = {
    files: []
  };

  removeFile = () =>
    this.setState({files: []}, () => this.props.clearFields('avatar'));

  onFileDrop = files => {
    const storeIdentifierAction = identifier =>
      change('addTeamDetails', 'avatar', identifier);

    const storeImageUrlAction = imageUrl =>
      storeDataInModal({
        modalName: MODALS.ADD_TEAM,
        data: {
          avatarUrl: imageUrl
        }
      });

    const startUploadingAction = () =>
      storeDataInModal({
        modalName: MODALS.ADD_TEAM,
        data: {
          uploading: true
        }
      });

    const finishUploadingAction = () =>
      storeDataInModal({
        modalName: MODALS.ADD_TEAM,
        data: {
          uploading: false
        }
      });

    const file = files[0];
    const signSdk = teamAvatarSignOnCreate;
    const signData = {filename: file.name, fileType: file.type};

    this.setState({files: files}, () =>
      this.props.uploadFile({
        file,
        signSdk,
        signData,
        startUploadingAction,
        finishUploadingAction,
        storeIdentifierAction,
        storeImageUrlAction
      })
    );
  };

  componentDidMount() {
    this.props.fetchLocations();
  }

  render() {
    const {locations, uploading} = this.props;
    const {files} = this.state;
    return (
      <form className="AddTeamDetailsForm" onSubmit={this.props.handleSubmit}>
        <Section number="1" heading="Choose Team Name">
          <FormField>
            <Label>Name</Label>
            <Field
              name="teamName"
              component={TextField}
              placeholder="How do you want their name to appear?"
              validate={[required]}
            />
          </FormField>
        </Section>
        <Section number="2" heading="Add Team Picture">
          <FormField className="uploadTeamPicture">
            <Field
              name="avatar"
              component={DropzoneField}
              onFileDrop={this.onFileDrop}
              removeFile={this.removeFile}
              multiple={false}
              uploading={uploading}
              files={files}
              acceptedFileTypes={ACCEPTED_IMAGE_FILE_TYPES}
              type={Dropzone.SMALL}
            />
          </FormField>
        </Section>
        <Section number="3" heading="Choose Team Location">
          <div className="locationsList">
            {locations.map(location => (
              <div key={location.id} className="locationRow">
                <div
                  className="image"
                  style={{backgroundImage: `url(${location.thumbnailImage})`}}
                />
                <div className="info">
                  <div className="name">{location.name}</div>
                  <div className="address">{location.address.country}</div>
                </div>
                <FormField>
                  <Field
                    name={`locations.${location.ref}`}
                    component={CheckBoxField}
                  />
                </FormField>
              </div>
            ))}
          </div>
        </Section>
      </form>
    );
  }
}

const mapStateToProps = state => {
  const {data: {uploading}} = selectModal(state, MODALS.ADD_TEAM);

  return {locations: selectLocations(state), uploading};
};

const mapDispatchToProps = {fetchLocations, uploadFile};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({form: 'addTeamDetails', enableReinitialize: true})(
    AddTeamDetailsForm
  )
);
